document.querySelectorAll('[data-faq-list]').forEach((list) => {
  list.querySelectorAll('details.faq__item').forEach((details) => {
    const summary = details.querySelector('summary.faq__question');
    const answer = details.querySelector('.faq__answer');
    if (!summary || !answer) return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (details.dataset.animating === 'true') return;

      if (details.open) {
        collapse(details, answer);
      } else {
        list.querySelectorAll('details[open]').forEach((other) => {
          if (other !== details) collapse(other, other.querySelector('.faq__answer'));
        });
        expand(details, answer);
      }
    });
  });
});

function expand(details, answer) {
  details.dataset.animating = 'true';
  details.open = true;
  answer.style.height = '0px';
  answer.offsetHeight;
  answer.style.height = answer.scrollHeight + 'px';

  const handler = (event) => {
    if (event.propertyName !== 'height') return;
    answer.style.height = '';
    details.dataset.animating = '';
    answer.removeEventListener('transitionend', handler);
  };
  answer.addEventListener('transitionend', handler);
}

function collapse(details, answer) {
  details.dataset.animating = 'true';
  answer.style.height = answer.scrollHeight + 'px';
  answer.offsetHeight;
  answer.style.height = '0px';

  const handler = (event) => {
    if (event.propertyName !== 'height') return;
    details.open = false;
    answer.style.height = '';
    details.dataset.animating = '';
    answer.removeEventListener('transitionend', handler);
  };
  answer.addEventListener('transitionend', handler);
}
